import { JsToClientCommand } from '../jsToClientCommand';
import { ClientCommands } from '../clientCommands';

export class SetClientNotificationsStateHandler extends JsToClientCommand<{}> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(params: {[key:string]: any}) {
        super(ClientCommands.SET_CLIENT_NOTIFICATIONS_STATE, params);
    }
}
